<h1>{{ 'turbo.Service.IssueNoteDialog.txtHeadline2' | translate : 'Add a comment to your change' }}</h1>
<t4-container >

  <mat-form-field appearance="fill" *ngIf="enableTags">
    <mat-label> Select Tag </mat-label>
    <mat-select required [(ngModel)]="selectedTags" #name="ngModel">
      <mat-option value="Tak">Takskada</mat-option>
      <mat-option value="Trafikolycka">Trafikolycka</mat-option>
      <mat-option value="Tappat">Tappat</mat-option>
      <mat-option value="Motparts">Motpartsskada</mat-option>
      <mat-option value="Vinch">Vinch</mat-option>
      <mat-option value="Stöld">Stöld</mat-option>
      <mat-option value="Stöld-delar">Stöld-delar</mat-option>
      <mat-option value="Stöldskada">Stöldskada</mat-option>
      <mat-option value="Övrigt">Övrigt</mat-option>
    </mat-select>
    <mat-error *ngIf="!selectedTags?.length">You must select a Tag.</mat-error>
  </mat-form-field>


  <mat-form-field style="width: 100%">
    <textarea matInput placeholder="{{'Turbo.OneWayAdmin.IssueNoteDialog.txtComment' | translate : 'Comment'}}" [formControl]="ctrlComment" matTextareaAutosize matAutosizeMinRows="5" matAutosizeMaxRows="5"></textarea>
  </mat-form-field>
  <mat-form-field style="width: 100%">
    <input matInput [formControl]="ctrlNewEstimatedDate" placeholder="{{'Turbo.OneWayAdmin.IssueNoteDialog.txtEstimatedDate' | translate : 'New estimated completion date'}}" [matDatepicker]="myDatepicker" [min]="tomorrow" />
    <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #myDatepicker></mat-datepicker>
  </mat-form-field>

  <mat-checkbox *ngIf="Settings.isInAny(['OneWayAdmin']) && data.showActivationOption" [(ngModel)]="activateObject">{{ 'Turbo.Service.IssueNoteDialog.ActivateRentalObject' | translate : 'Activate rental object' }}</mat-checkbox>
</t4-container>
    <div style="text-align: center;">
        <button mat-raised-button color="primary" class="btn btn-default" style="margin: 2px;" color="primary" (click)="save()" [disabled]="!selectedTags?.length && enableTags">{{ 'turbo.Service.IssueNoteDialog.cmdSave' | translate : 'Save' }}</button>
        <button mat-stroked-button color="primary" class="btn btn-default" style="margin: 2px;" [mat-dialog-close]="false">{{ 'turbo.Service.IssueNoteDialog.cmdCancel' | translate : 'Cancel' }}</button>
    </div>
